import { render, staticRenderFns } from "./navigation.vue?vue&type=template&id=09d1a3b8&scoped=true"
import script from "./navigation.vue?vue&type=script&lang=js"
export * from "./navigation.vue?vue&type=script&lang=js"
import style0 from "./navigation.vue?vue&type=style&index=0&id=09d1a3b8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d1a3b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2585860866/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09d1a3b8')) {
      api.createRecord('09d1a3b8', component.options)
    } else {
      api.reload('09d1a3b8', component.options)
    }
    module.hot.accept("./navigation.vue?vue&type=template&id=09d1a3b8&scoped=true", function () {
      api.rerender('09d1a3b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/navigation.vue"
export default component.exports